import { getCachedFlagValueKey } from '#pplx/frontend/experimentation/cachedFlagValue.js';
import { makeCachedFlagValueHook, useBooleanNonExperimentFlagValue, } from '#pplx/frontend/experimentation/hooks.js';
export const useMarbleEnabled = makeCachedFlagValueHook(getCachedFlagValueKey('web-teammates-ui'), function useMarbleFlag({ defaultValue }) {
    return useBooleanNonExperimentFlagValue({ flag: 'web-teammates-ui', defaultValue });
}, 'web-teammates-ui');
//# sourceMappingURL=useMarbleEnabled.js.map